import React, { useRef, useState, useEffect } from "react";

import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

import gold from "../assets/gold.png";
import peso from "../assets/peso.png";

function TooltipGComponent({ nivel, datosProcesados, children }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [datosNivel, setDatosNivel] = useState([]);

  useEffect(() => {
    if (nivel["color"] === "#a50011") setShowTooltip(false);
    else setShowTooltip(true);
  }, [nivel["color"]]);

  //filtra los datos procesados acorde al registro seleccionado
  useEffect(() => {
    
    if(showTooltip)
    {

      let result = datosProcesados.find((item) => item.nivel == nivel["nivel"]);

      let totalToneladas = 0;
      let sumAuEq_Gr_t = 0; //AuEq Gr/t
      let sumAu_Gr_t = 0; // Au Gr/t
      let sumCu_pct = 0; // Cu%
      let sumFe_pct = 0; //fe%

      if (result?.data?.length > 0) {
        result.data.forEach((registro) => {
          const toneladas = Number(registro[13]) || 0;
          const auEq_Gr_t = Number(registro[15]) || 0;
          totalToneladas += toneladas;

          sumAu_Gr_t += toneladas * (Number(registro[16]) || 0); //='Au * tons'/Toneladas
          sumCu_pct += toneladas * (Number(registro[19]) || 0); //='Cu% * tons '/Toneladas
          sumAuEq_Gr_t += toneladas * auEq_Gr_t; //='AuEq * tons'/Toneladas
          sumFe_pct += toneladas * (Number(registro[20]) || 0); //='Fe * tons'/Toneladas
        });
      }

      const dividir = (total) =>
        totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";

      setDatosNivel({
        sumTonelada: totalToneladas.toFixed(2),
        AuEq_Gr_t: dividir(sumAuEq_Gr_t),
        Au_Gr_t: dividir(sumAu_Gr_t),
        Cu_pct: dividir(sumCu_pct),
        Fe_pct: dividir(sumFe_pct),
      });
    }
  }, [showTooltip, datosProcesados]);

  const tooltipStyles = (theme) => {
    const lightStyles = {
      backgroundColor: "#eaeaea",
      color: "#4f4f4f",
      border: "1px solid #dadde9",
      boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
    };

    return {
      [`& .${tooltipClasses.tooltip}`]: {
        ...lightStyles,
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(10),
      },
      [`& .${tooltipClasses.arrow}`]: {
        color: "transparent",
        fontSize: "15px",
        "&::before": {
          ...lightStyles,
          boxSizing: "border-box",
        },
      },
    };
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      arrow
      placement="right"
      classes={{ popper: className }}
    />
  ))(({ theme }) => tooltipStyles(theme));

  return (
    <HtmlTooltip
      title={
        <>
          <p className="text-sm  font-bold">{nivel["nivel"]}</p>
          <div className="mt-2">
            <div className="flex">
              <img className="w-[15px] h-[15px] mr-1" src={peso} />
              <p className="text-sm font-bold">Toneladas:</p>
              <p className="text-[12px] ml-1 mt-[2px]">
                {" "}
                {datosNivel.sumTonelada}{" "}
              </p>
            </div>
          </div>

          <div>
            <div className="flex">
              <img className="w-[15px] h-[15px] mr-1" src={gold} />
              <p className="text-sm  font-bold">AuEq g/t:</p>
              <p className="text-[12px] ml-1 mt-[2px]">
                {" "}
                {datosNivel.AuEq_Gr_t}{" "}
              </p>
            </div>
          </div>

          <div>
            <div className="flex">
              <img className="w-[15px] h-[15px] mr-1" src={gold} />
              <p className="text-sm  font-bold">Au Gr/t:</p>
              <p className="text-[12px] ml-1 mt-[2px]">
                {" "}
                {datosNivel.Au_Gr_t}{" "}
              </p>
            </div>
          </div>

          <div>
            <div className="flex">
              <img className="w-[15px] h-[15px] mr-1" src={gold} />
              <p className="text-sm  font-bold">Cu %:</p>
              <p className="text-[12px] ml-1 mt-[2px]"> {datosNivel.Cu_pct} </p>
            </div>
          </div>

          <div>
            <div className="flex">
              <img className="w-[15px] h-[15px] mr-1" src={gold} />
              <p className="text-sm  font-bold">Fe %:</p>
              <p className="text-[12px] ml-1 mt-[2px]"> {datosNivel.Fe_pct} </p>
            </div>
          </div>
        </>
      }
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      disableHoverListener={!showTooltip}
      disableFocusListener={!showTooltip}
      disableTouchListener={!showTooltip}
    >
      {children}
    </HtmlTooltip>
  );
}

export default TooltipGComponent;
